import { ChangeEvent, useCallback, useEffect, useMemo, useState } from "react";
import { getItemPopupList } from "src/apis/itemApi";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { ItemDto } from "src/dtos/item/itemDto";
import useUiuxStore from "src/store/useUiuxStore";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useTQC2020_R01Store, { defaultTQC2020_R01Filter } from "./Store_TQC2020_R01";
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { CompanyDto } from "src/dtos/company/companyDto";
import { WorkPlaceDto } from "src/dtos/workplace/workPlaceDto";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import { EmployeeDto } from "src/dtos/employee/employeeDto";
import { getEmployeeList } from "src/apis/employeeApi";
import {  SearchSpacer } from "src/components/common/common";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";

interface Props {}

export const SearchSection_TQC2020_R01 = ({}: Props) => {
    const {
        TQC2020_R01Filter, 
        setTQC2020_R01Filter
    } = useTQC2020_R01Store();

    const {
        brandCdList,         // ✅ 브랜드 공통코드
        workPlaceList,         // ✅ 작업공정 공통코드
        compCdList         // ✅ 사업장 공통코드
    } = useCommonCodeStore();

    const { setCodeSearchModalProps } = useUiuxStore();

    const [itemName, setItemName] = useState<string>("");
    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
    const [productEmpName, setProductEmpName] = useState<string>("");

	const handleItemFoucsId = 'itemCd_search';
	const handleProductEmpFoucsId = 'productEmp_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'itemCd',
			category: '품목',
			focusId: handleItemFoucsId,
			responseMapping: {
				itemCd: 'itemCd',
				itemNm: 'itemNm',
			},
			extraFilter: () => ({
				itemCd: TQC2020_R01Filter.itemCd || '',
				itemNm: TQC2020_R01Filter.itemNm || '',
			}),
		},
		{
			fieldName: 'workerEmp',
			category: '작업자',
			focusId: handleProductEmpFoucsId,
			responseMapping: {
				empNo: 'workerEmp',
				empNm: 'workerEmpNm',
			},
			extraFilter: () => ({
                workerEmp: TQC2020_R01Filter.workerEmp || '',
				workerEmpNm: TQC2020_R01Filter.workerEmpNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: TQC2020_R01Filter,
		setEditData: setTQC2020_R01Filter,
		defaultData: defaultTQC2020_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'TQC2020_R01_search'
	});

    // useEffect(() => {
    //     if (TQC2020_R01Filter.productDt?.from && TQC2020_R01Filter.productDt?.to) {
    //         // 로컬 시간대 기준으로 YYYY-MM-DD 형식 생성 (UTC 변환 방지)
    //         const formatDate = (date: Date) => {
    //             const year = date.getFullYear();
    //             const month = String(date.getMonth() + 1).padStart(2, '0');
    //             const day = String(date.getDate()).padStart(2, '0');
    //             return `${year}-${month}-${day}`;
    //         };
            
    //         const fromDate = formatDate(TQC2020_R01Filter.productDt.from);
    //         const toDate = formatDate(TQC2020_R01Filter.productDt.to);
            
    //         setTQC2020_R01Filter({
    //             startDate: fromDate,
    //             endDate: toDate
    //         });
    //     } else {
    //         setTQC2020_R01Filter({
    //             startDate: '',
    //             endDate: ''
    //         });
    //     }
    // }, [TQC2020_R01Filter.productDt, setTQC2020_R01Filter]);

    return (
        <div className="w-full">
            <SearchSectionDoubleForm >

            <SearchDropDownForm<CompanyDto>
                    label="사업장"
                    value={TQC2020_R01Filter.compCd}
                    optionList={compCdList}
                    onChangeValue={v => setTQC2020_R01Filter({ compCd: v === 'all' ? '' : v })}
                />
                <SearchDateRangeForm
                    label="검사기간 "
                    visible={pickerVisible}
                    setVisible={setPickerVisible}
                    dateRange={TQC2020_R01Filter.productDt}
                    setDateRange={v => setTQC2020_R01Filter({ productDt: v })}
                    pickerPosition={pickerPosition}
                    setPickerPosition={setPickerPosition}
                    wrapperOption={{
                        wrapperStyle: "w-[290px] min-w-[290px] mr-[10px]",
                    }}
                />
                <SearchDropDownForm<WorkPlaceDto>
                    label="작업공정"
                    value={TQC2020_R01Filter.workplaceCd}
                    optionList={workPlaceList}
                    onChangeValue={(v) =>
                        setTQC2020_R01Filter({
                            workplaceCd: v === "all" ? "" : v,
                        })
                    }
                />
                <SearchSpacer/>

                {/* 브랜드 선택 */}
                <SearchDropDownForm<SysCodeDto>
                    label="브랜드"
                    value={TQC2020_R01Filter.brandCd}
                    optionList={brandCdList}
                    onChangeValue={(v) =>
                        setTQC2020_R01Filter({
                            brandCd: v === "all" ? "" : v,
                        })
                    }
                />

                {/* 품목 검색 */}
                <SearchCodeModalForm
                    label="품목코드"
                    value={TQC2020_R01Filter.itemCd}
                    valueLabel={TQC2020_R01Filter.itemNm}
                    handleFoucsId={handleItemFoucsId}
                    onChange={getFieldHandlers('itemCd').onChange}
                    onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
                    onKeyDown={getFieldHandlers('itemCd').onEnterKeyDown}
                />

                <SearchCodeModalForm
                    label="작업자"
                    value={TQC2020_R01Filter.workerEmp}
                    valueLabel={TQC2020_R01Filter.workerEmpNm}
                    handleFoucsId={handleProductEmpFoucsId}
                    onChange={getFieldHandlers('workerEmp').onChange}
                    onDoubleClick={getFieldHandlers('workerEmp').onDoubleClick}
                    onKeyDown={getFieldHandlers('workerEmp').onEnterKeyDown}
                />

            </SearchSectionDoubleForm>
        </div>
    );
};
